var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelpop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2701 20.0015L26.9973 14.2742C27.361 13.9106 27.361 13.3651 26.9973 13.0015C26.6337 12.6379 26.0882 12.6379 25.7246 13.0015L19.9973 18.7288L14.2701 13.0015C13.9064 12.6379 13.361 12.6379 12.9973 13.0015C12.6337 13.3651 12.6337 13.9106 12.9973 14.2742L18.7246 20.0015L12.9973 25.7288C12.8155 25.9106 12.7246 26.0924 12.7246 26.3651C12.7246 26.9106 13.0882 27.2742 13.6337 27.2742C13.9064 27.2742 14.0882 27.1833 14.2701 27.0015L19.9973 21.2742L25.7246 27.0015C25.9064 27.1833 26.0882 27.2742 26.361 27.2742C26.6337 27.2742 26.8155 27.1833 26.9973 27.0015C27.361 26.6379 27.361 26.0924 26.9973 25.7288L21.2701 20.0015Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelpop);
export default __webpack_public_path__ + "static/media/cancelpop.861424d4cec1f871a756ccee334c4959.svg";
export { ForwardRef as ReactComponent };